
import { Component, Vue } from 'vue-property-decorator'
import GoodsCategorySelect from '@/views/goodsManage/commodity/template/GoodsCategorySelect.vue'
import commdsTig from '@/views/goodsManage/commodity/subPage/commdsTig.vue'
import GoodsCategoryModal from '@/views/goodsManage/commodity/template/GoodsCategoryModal.vue'
import commdsBrand from '@/views/goodsManage/commodity/subPage/commdsBrand.vue'
import { brandDto, categoryDto, goodsDetailDto } from "@/api/goods"
import {
  addGoodsSubmit,
  getGoodsBrandList,
  GoodsBrandListDto,
  GoodsSubmitDto,
  GoodsTagListDto,
  isGoodsNameExist,
  manipulationKeyword
} from "@/api/commodity"
import { goodsCodeEvent } from '@/constant/event';
import { Form } from 'vant';
import { getPinyin } from '@/utils/util'
Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    GoodsCategorySelect,
    commdsTig,
    GoodsCategoryModal,
    commdsBrand
  }
})
export default class GoodsBaseInfo extends Vue {
  $refs!: {
    goodsCategorySelect: GoodsCategorySelect;
    goodsForm: Form;
    commdsTig: commdsTig,
    addClass: GoodsCategoryModal;
    commdsBrand
  }
  isGoodsNameExist = isGoodsNameExist
  labelWidth = '7em'
  showLevelPicker = false
  brandList: GoodsBrandListDto[] = []
  formText = {
    goodsTagNameList: '',
    categoryName: ''
  }
  formData = {
    goodsId: '', // 商品编号
    goodsName: '', // 商品名称
    categoryId: undefined, // 商品分类
    brandId: undefined, // 商品品牌
    brandName: '',
    keyword: '', // 关键字
    goodsTagIdList: [], // 商品标签
    goodsCode: '' // 商品编码
  }
  oldGoodsName: ''

  activated () {
    // if (this.$route.query.currTag) {
    //   const tags = this.$route.query.currTag as []
    //   this.formText.goodsTagNameList = ''
    //   this.formData.goodsTagIdList = []
    //   this.formData.goodsTagIdList = tags.map((item: GoodsTagListDto) => {
    //     this.formText.goodsTagNameList = `${this.formText.goodsTagNameList ? `${this.formText.goodsTagNameList}、` : this.formText.goodsTagNameList}${item.tagName}`
    //     return {
    //       goodsTagId: item.tagId
    //     }
    //   })
    // }
  }

  created () {
    this.initGoodsCode()
    this.getGoodsBrandList()
  }

  beforeRouteLeave (to, from, next) {
    next();
  }

  get $isCopy () {
    return 'copy' === this.$route.query.op as string
  }
  get type () {
    return this.$route.query.op
  }

  initGoodsCode () {
    if (!(this.type === 'edit') || this.$isCopy) {
      // 生产随机商品编码
      this.formData.goodsCode = `G${Date.now()}`
    }
    this.handleGoodsCodeBlur()
  }

  /**
   * 商品分类弹框打开
   */
  handleCategoryShow(){
    this.$eventBus.$emit('currentPage', 2)
    this.$refs.addClass.showModal()
  }

  /**
   * 商品分类界面原生返回功能调用
   */
  handleCategoryAppCancel(){
    this.$refs.addClass.handleBack()
  }
  /**
   * 商品品牌界面原生返回功能调用
   */
  handleBrandAppCancel(){
    this.$refs.commdsBrand.handleBack()
  }
  /**
   * 商品标签界面原生返回功能调用
   */
  handlTigAppCancel(){
    this.$refs.commdsTig.handleBack()
  }

  /**
   * 商品品牌弹框打开
   */
  handleBrandShow(){
    this.$eventBus.$emit('currentPage', 3)
    this.$refs.commdsBrand.showModal(this.formData.brandId)
  }

  handleGoodsCodeBlur () {
    this.$nextTick(() => {
      this.$eventBus.$emit(goodsCodeEvent, this.formData.goodsCode)
    })
  }

  getGoodsNameRule () {
    return [
      { required: true, message: '', trigger: 'onBlur' },
      {
        validator: (value, rule) => {
          let exceptGoodsId = ''
          if (this.$isEdit) {
            exceptGoodsId = this.formData.goodsId
            return true
          }
          return new Promise(resolve => {
            isGoodsNameExist({ exceptGoodsId, goodsName: value }).then(res => {
              resolve(!res.data.isExist)
            })
          })
        },
        message: '商品名称不能重复'
      }
    ]
  }

  brandConfirm (value: brandDto) {
    this.formData.brandName = value.brandName
    this.formData.brandId = value.brandId
    this.showLevelPicker = false
  }
  toGoodsTag () {
    // this.$router.push({ name: 'CommdsTig' })
    this.$eventBus.$emit('currentPage', 4)
    this.$refs.commdsTig.showModal(this.formData.goodsTagIdList)
  }
  handleSaveTag (currTag: []) {
    if (currTag) {
      const tags = currTag
      this.formText.goodsTagNameList = ''
      this.formData.goodsTagIdList = []
      this.formData.goodsTagIdList = tags.map((item: GoodsTagListDto) => {
        this.formText.goodsTagNameList = `${this.formText.goodsTagNameList ? `${this.formText.goodsTagNameList}、` : this.formText.goodsTagNameList}${item.tagName}`
        return item.tagId
      })
    }
  }
  handleSaveBrand (brand: GoodsBrandListDto) {
    this.$eventBus.$emit('currentPage', 1)
    this.formData.brandId = brand.brandId
    this.formData.brandName = brand.brandName
  }
  getGoodsBrandList () {
    getGoodsBrandList({ isPage: false }).then(res => {
      this.brandList = res.data
    })
  }
  /**
   * 商品分类回调
   */
  handleSelectCategory (data: categoryDto) {
    this.$eventBus.$emit('currentPage', 1)
    this.formData.categoryId = data.categoryId
    this.formText.categoryName = data.categoryName
  }
  setData (data: goodsDetailDto) {
    if (data.goodsName) {
      // @ts-ignore
      this.oldGoodsName = data.goodsName || ''
    }
    Object.keys(this.formData).forEach(key => {
      // @ts-ignore
      this.formData[key] = data[key]
    })
    this.formData.goodsTagIdList = data.goodsTagList!.map(item => item.tagId) as []
    this.formText.categoryName = data.categoryName
    data.goodsTagList.forEach(item => {
      this.formText.goodsTagNameList = `${this.formText.goodsTagNameList ? `${this.formText.goodsTagNameList}、` : this.formText.goodsTagNameList}${item.tagName}`
    })
    this.initGoodsCode()
  }
  handleSubmit () {
    return new Promise((resolve, reject) => {
      (this.$refs.goodsForm as Form).validate().then(res => {
        resolve(JSON.parse(JSON.stringify(this.formData)))
      })
    })
  }
  getscr(ele) {
    ele.currentTarget.scrollIntoView()
  }
  extractKey () {
    if (!this.formData.goodsName) return
    let param = {
      oldGoodsName: this.oldGoodsName,
      newGoodsName: this.formData.goodsName,
      keyword: this.formData.keyword
    }
    manipulationKeyword(param).then(res => {
      // @ts-ignore
      this.formData.keyword = res.data
    })
    // this.formData.keyword = getPinyin(this.formData.goodsName, { pattern: 'first', toneType: 'none' })
  }
}
